import { EmptyWrapper, EmptyWrapperSubTitle, EmptyWrapperTitle } from "../styles";

export const EmptyDescription = () => {
    return (
      <EmptyWrapper>
        <EmptyWrapperTitle>No transactions yet</EmptyWrapperTitle>
        <EmptyWrapperSubTitle>All received refund transactions will appear here.</EmptyWrapperSubTitle>
      </EmptyWrapper>
    );
  };